export default "__VITE_ASSET__f21f37c1__"